import { Dialog, IconButton, Slide } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { useStyles } from '@webapps/styles';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';

import theme from './theme';

const {
  colors: { dialogTitleColor },
} = theme;

const Transition = forwardRef(({ direction, ...props }, ref) => (
  <Slide ref={ref} direction={direction} {...props} />
));

Transition.propTypes = {
  direction: PropTypes.string,
};

const ModalSidebar = ({
  children,
  handleClose,
  open,
  position = 'right',
  title,
  titleSize = '18px',
  width,
  button,
  MontserratTitle = false
}) => {
  const { classes, css, cx, global } = useStyles(styles);

  const direction = position === 'right' ? 'left' : 'right';

  return (
    <Dialog
      BackdropProps={{
        style: {
          backgroundColor: 'rgba(0, 45, 117, 0.6)',
        },
      }}
      classes={{
        scrollPaper: css({
          justifyContent: position === 'right' ? 'flex-end' : 'flex-start',
        }),
        paperScrollPaper: css({
          height: '100%',
          maxHeight: '100%',
          width,
          maxWidth: width || "640px",
          overflowX: 'hidden',
        }),
        paper: css({ margin: 0 }),
      }}
      onClose={() => {
        handleClose();
      }}
      open={open}
      TransitionComponent={Transition}
      TransitionProps={{ direction }}
    >
      <div style={{ display: title ? 'block' : 'none' }}>
        <div
          className={title ? classes.buttonContainer : classes.buttonContainerEnd}
        >
          {title && (
            <div
              className={css({
                fontSize: titleSize,
                fontWeight: 700,
                color: '#152652',
                fontFamily: MontserratTitle ? 'Montserrat' : 'Roboto',
              })}
            >
              {title}
            </div>
          )}

          <div className={
            css({
              display: 'flex',
            })
          }>

            {
              button && button
            }
            <IconButton
              className={cx(css({
                background: '#F3F7FF',
                border: '1px solid #C0D9FF',
                width: '26px',
                height: '26px',
              }), global.buttonBase)}
              onClick={() => {
                handleClose();
              }}
              size="small"
            >
              <Close className={global.buttonIcon} />
            </IconButton>

          </div>
        </div>
      </div>
      <div className={classes.dialogContent}>{children}</div>
    </Dialog >
  );
};

const styles = ({ titleSize, fontSizes, spacing }) => ({
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: spacing(2.5),
  },
  buttonContainerEnd: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: spacing(2.5),
  },
  dialogHeader: {
    display: 'flex',
    marginTop: spacing(1),
    alignItems: 'center',
    marginBottom: spacing(2),
    paddingLeft: spacing(2),
  },
  dialogContent: {
    padding: '0px 24px',
    position: 'relative',
  },
});

ModalSidebar.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  position: PropTypes.string,
  children: PropTypes.node,
  title: PropTypes.node,
  width: PropTypes.number,
};

export default ModalSidebar;
